import React from 'react'

import SignUp from './SignUp'
import SignIn from './SignIn'
import Recovery from './Recovery'
import { AuthType } from '../../types/enums'

interface AuthProps {
    type: AuthType;
    signin?: boolean | null;
    signup?: boolean | null;
    recovery?: boolean | null;
}

export default function AuthUI({ type, signin, signup, recovery }: AuthProps) {
    if (signin) {
        return <SignIn type={type} />
    } else if (signup) {
        return <SignUp type={type} />
    } else if (recovery) {
        return <Recovery type={type} />
    } else {
        return null
    }
}
